import { useEffect, useState } from 'react';
import { getSyncState, subscribeSync, type SyncState } from '@/services/syncService';

/** Subscribes to the sync service so the header can show pending deliveries. */
export function useSyncState(): SyncState {
  const [state, setState] = useState<SyncState>(getSyncState);
  useEffect(() => subscribeSync(setState), []);
  return state;
}
